var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStepReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5455 3.81818H14.7455C14.3636 2.76364 13.3636 2 12.1818 2C11 2 10 2.76364 9.61818 3.81818H5.81818C4.81818 3.81818 4 4.63636 4 5.63636V20.1818C4 21.1818 4.81818 22 5.81818 22H18.5455C19.5455 22 20.3636 21.1818 20.3636 20.1818V5.63636C20.3636 4.63636 19.5455 3.81818 18.5455 3.81818ZM12.1818 3.81818C12.6818 3.81818 13.0909 4.22727 13.0909 4.72727C13.0909 5.22727 12.6818 5.63636 12.1818 5.63636C11.6818 5.63636 11.2727 5.22727 11.2727 4.72727C11.2727 4.22727 11.6818 3.81818 12.1818 3.81818ZM18.5455 20.1818H5.81818V5.63636H7.63636V8.36364H16.7273V5.63636H18.5455V20.1818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStepReport);
export default __webpack_public_path__ + "static/media/icon_step_report.25aaf62ff22e9497b56bbdef1869a2cf.svg";
export { ForwardRef as ReactComponent };